import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { DefaultPalette, mergeStyleSets, Text } from '@fluentui/react';
import * as PropTypes from 'prop-types';
const classes = mergeStyleSets({
    freeTrialText: {
        color: DefaultPalette.green,
        background: '#DFF6DD',
        padding: '5.25px 8px 7px 8px',
        borderRadius: 2,
        fontSize: 13,
        height: 28,
        display: 'inline-block'
    }
});
export const FreeTrialBadge = (_, context)=>{
    return /*#__PURE__*/ _jsx(Text, {
        className: classes.freeTrialText,
        nowrap: true,
        variant: "smallPlus",
        children: context.loc('CTA_Try')
    });
};
FreeTrialBadge.contextTypes = {
    loc: PropTypes.func
};
